// Host-owned pending-modal state backing slate.window.showModal. The worker asks
// the host to open a modal surface; this parks the request and resolves the
// returned promise when the user closes the modal. Mirrors consentStore so the
// modal is always host-rendered, never plugin-rendered.

import { create } from 'zustand';

export interface PendingModal {
  pluginId: string;
  surfaceId: string;
  resolve: () => void;
}

interface ModalState {
  pending: PendingModal | null;
  open(pluginId: string, surfaceId: string): Promise<void>;
  close(): void;
}

export const useSurfaceModalStore = create<ModalState>((set, get) => ({
  pending: null,
  open: (pluginId, surfaceId) =>
    new Promise<void>((resolve) => set({ pending: { pluginId, surfaceId, resolve } })),
  close: () => {
    const p = get().pending;
    if (p) {
      p.resolve();
      set({ pending: null });
    }
  },
}));

/** The showModal callback the plugin system uses, backed by the store above. */
export function showModalViaStore(pluginId: string, surfaceId: string): Promise<void> {
  return useSurfaceModalStore.getState().open(pluginId, surfaceId);
}
